import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import request from './utils/request'
import MobileDetect from "mobile-detect"

//防止引入无效
const wx = require("weixin-js-sdk") || window["wx"];

console.log('wx',wx);

console.log('href',location.href);

//环境判断
if($systemEnviron() != 3){  //wx
    Vue.prototype.wx = wx;
}
else{
    // Vue.prototype.wx = $wxAPP;
    Vue.prototype.wx = $wx_APP();
}

import Bus from 'vue'
Vue.prototype.bus  = new Bus();

import {WXUSERHOST,mapEventManger,mapFunManger} from "./config/config"

import { getPlugInfo, createMap, createQQMap,createQueryQQMap,getActivityDataInfo,getActivePushInfo,
    getPoiDetailDataInfo,getCollectData,getHistoryFootData,
    getRecommendData,getHotWords,getThemeActivity,getNavAreaPoint,getWXUserInfo} from './config/prepare.js';

import { isShow , dataFormat,getParam,$system,$wx_APP,$systemEnviron,hexToRgba,getWeekStr} from "./utils/util";

import {_getPoiInfo} from "@/utils/search_poi_extend";

import Message from './components/message'

import {_init_makers,_init_locate,getPoiInfo} from '@/views/map/modules/brtmap/Brtmap.js';

import {get_wx_sign} from "@/views/map/modules/bottomGather/modules/LocateModule.js";



//蓝牙处理
// 定位状态  -2  未开启GPS   -1 未开启蓝牙   0:无定位    1:定位中    2:定位成功
Vue.prototype.$BlueState = getParam('locationState');

//取sign
Vue.prototype.$sign = getParam('sign') || sessionStorage.getItem('sign') || 'd5e026d3d93741198b8e7af68aa9c061';



//注册特殊操作序列
Vue.prototype.$mapEventManger = mapEventManger;

//功能或流程开关
Vue.prototype.$mapFunManger = mapFunManger;

//引用左右滑动
import VueTouch from 'vue-touch'
Vue.use(VueTouch, {name: 'v-touch'})
Vue.config.productionTip = false;

//页面ios滚动处理
import { enableScroll } from "./utils/enableScroll"

Vue.prototype.$enableScroll = enableScroll;

// console.log('Vue.prototype.wx',Vue.prototype.wx);

//加载
import Loading from './components/loading'
Vue.prototype.$loading = Loading;

//键盘注册
import brtKeyBoard from './components/brtKeyBoard'
Vue.prototype.$brtKeyBoard = brtKeyBoard;


//实例数据上报
import UserOperInfoHelper from "./utils/updata"
let $userUpdata = new UserOperInfoHelper();
Vue.prototype.$userUpdata = $userUpdata;

import {HOST} from "./config/config";
Vue.prototype.$axiosBaseUrl = HOST;

// request
Vue.prototype.$request = request;
// message
Vue.prototype.$message = Message;

Vue.prototype.$system = $system();

Vue.prototype.$systemEnviron = $systemEnviron();

//用户信息
let $WXUSERINFO = {
    nickname:``,
    headimgurl:'',
    openid:'',
    sex:0,      //0：未知 1男 2：女
    city:'',
    province:'',
    age:0
};
Vue.prototype.$WXUSERINFO = $WXUSERINFO;

//路由拦截
let $pageError = false;
router.beforeEach((to, from, next) => {

    if(!store.state.appLoad){
        if(to.query.userUpdataAi){
            store.state.appLoad = 2;
        }else{
            store.state.appLoad = 1;
        }
    }

    if(!to.name){

        next('/error');

    }else if(to.name == 'Error'){

        $pageError = true;
        next();

    }else{

        $pageError = false;
        next();
    }
});


//拦截地址(处理微信对vue分享#不友好操作)'http://p.brtbeacon.net/test/pro-maintain/3Dplug-CRH/v2.3.2-vue/test/dist/index.html?from=singlemessage#/map?sign=14839_05710008&poiId=3387'.split('?'),
let shareStr = window.location.href,
    shareUrl = window.location.href.split('?'),
    shareCurrentUrl='';


//分享被微信注入（ios）
if(shareStr.match('/index.html') && !shareStr.match('/index.html#/') && shareUrl[1].match('#/')){

    shareUrl.map((item,index)=>{
        if(index == 1){
            shareCurrentUrl += '#/' + shareUrl[1].split('#/')[1] + '?';
        }else{
            shareCurrentUrl += item;
        }
    })

    if(shareUrl.length == 2){
        shareCurrentUrl = shareCurrentUrl.slice(0,shareCurrentUrl.length - 1)
    }

    //重定向
    window.location.replace( shareCurrentUrl );
}

else{


    //小程序定位特殊参数获取
    if(getParam('location_user_id')){

        let locationParam = {
            sign:getParam('sign'),
            brand:getParam('brand'),
            applyId:getParam('applyId'),
            locationState:getParam('locationState'),
            location_user_id:getParam('location_user_id')
        }

        //存入数据
        localStorage.setItem('location_param',JSON.stringify(locationParam))
    }

    if($systemEnviron() === 2 && !getParam('location_user_id') && !!localStorage.getItem('location_param')){
        //缓存中转小程序定位问题 location_user_id  applyId

        let hrefString = location.href,
            locationParam = JSON.parse(localStorage.getItem('location_param'));

        if(location.href.indexOf('?')>-1){
            hrefString +='&';
        }else{
            hrefString +='?';
        }

        let ps = '';
        for(let key in locationParam){
            ps +=`${key}=${locationParam[key]}&`;
        }

        ps = ps.slice(0,ps.length-1);

        hrefString +=ps;

        //更改sign
        Vue.prototype.$sign = locationParam.sign;

        console.log('hrefString',hrefString);

        //篡改参数,定位抓取
        location.replace(hrefString);
    }




    getPlugInfo((res)=>{

        console.log('返回数据',res);

        //数据上报
        let WXUSERINFO = localStorage.getItem(`${res.buildingId}_WXUSERINFO`),
            _wxcallback = (Info)=>{

                //判断是否是首次打开应用(确保批次的准确性)
                if(!getParam('userUpdataAi')){

                    //设置建筑与用户ID
                    $userUpdata.init(res.buildingId,Info.openid);
                    // $userUpdata.init(`05120009`,Info.openid);

                    Info.age = Info.age || 0;

                    //设置用户信息 （昵称，头像地址，性别[1:男；2:女；0:未知], 年龄，城市，详细地址）
                    $userUpdata.setUser(Info.nickname,Info.headimgurl,Info.sex,Info.age,Info.province,`${Info.province}${Info.city}`);

                    //设置来源 (来源类型[1：分享；2：其他]，来源ID)
                    if(getParam('poiId')){
                        //分享
                        $userUpdata.setSource(1,getParam('poiId'))
                    }
                    else{
                        //非分享
                        $userUpdata.setSource(2)
                    }

                    //设置访问端信息 (品牌, 手机型号，浏览器信息，操作系统, app信息)
                    let $MobileDetect = new MobileDetect(navigator.userAgent),
                        brand = '',                          //手机品牌
                        brower = '',                         //浏览器信息
                        appInfo='',                          //app信息
                        os = $MobileDetect.os(),             //操作系统
                        mobile = $MobileDetect.mobile();     //手机型号


                    if($systemEnviron() !=3){

                        brower = appInfo = 'wechat';
                        if($systemEnviron() == 1){
                            appInfo = '小程序'
                        }

                    }
                    else{
                        brower = $MobileDetect.userAgent();
                        appInfo = 'app';
                    }

                    // console.log('navigator.userAgent',navigator.userAgent)
                    // console.log('手机品牌',brand,'手机型号',mobile,'浏览器信息',brower,'操作系统',os,'app信息',appInfo);
                    $userUpdata.setVisitTerminal(brand,mobile,brower,os,appInfo);

                }
                else{
                    $userUpdata.init(res.buildingId,Info.openid,getParam('userUpAi'));
                    // $userUpdata.init(`05120009`,Info.openid,getParam('userUpAi'));
                }

                //全局微信用户信息
                Info.ai = $userUpdata.ai;   //保存批次
                Vue.prototype.$WXUSERINFO = Object.assign({},$WXUSERINFO, Info);
                $WXUSERINFO = Info;
            };


        if(WXUSERINFO && typeof WXUSERINFO != "undefined"){

            _wxcallback && _wxcallback(JSON.parse(WXUSERINFO));

        }

        else{


            if($systemEnviron() !=3){
                //非app
                if(!getParam('openid')){
                    let url = location.href;

                    if(url.indexOf('?') > -1){
                        url += `&updata=1`;
                    }else{
                        url += `?updata=1`;
                    }

                    location.replace(`${WXUSERHOST}/auth/getOpenid?appId=${res.appId}&url=${encodeURIComponent(url.split('*')[0])}`);
                }
                else{

                    getWXUserInfo(getParam('openid'),(userInfo,err)=>{

                        if(err){
                            console.log('获取用户信息失败');
                        }else{
                            // console.log('微信用户信息',userInfo);
                            //存入微信用户信息
                            localStorage.setItem(`${res.buildingId}_WXUSERINFO`,JSON.stringify(userInfo));
                            _wxcallback  && _wxcallback(userInfo)
                        }
                    })

                }
            }

            else{

                //app
                WXUSERINFO = {
                    nickname:``,
                    headimgurl:'',
                    openid:+new Date(),
                    sex:1,      //0：未知 1男 2：女
                    city:'',
                    province:'',
                    age:0
                }

                localStorage.setItem(`${res.buildingId}_WXUSERINFO`,JSON.stringify(WXUSERINFO));

                _wxcallback  && _wxcallback(WXUSERINFO)
            }

        }


        store.state.mapStore.plugInfo = res;

        /***模块显示方法注册***/
        store.state.mapStore.isShow = isShow;

        /****注册地图控制***/
        Vue.prototype.$mapStore = store.state.mapStore;

        Vue.prototype.$BRT = store.state.mapStore.brtmap;

        Vue.prototype.$mapStep = store.state.mapStore.brtmap.$mapStep;

        Vue.prototype.$sign = res.sign;

        //增加日期原型方法
        dataFormat();

        /***创建地图,防止初始进入需要地图数据的版块 / 注册全局,方便调用 $VAR.map 地图相关操作***/
        // Vue.prototype.$brtmap = createMap(res);

        //替代变量(地图、检索、定位、导航,定位点)
        window.$VAR = createMap(res);

        //初始值
        $VAR.$nav = {};
        $VAR.$locate = '';          //定位点
        $VAR.PoiListMaker = [];
        $VAR.shopMakers = [];

        // console.log('$VAR',$VAR);

        Vue.prototype.$qqmap = createQQMap();

        //创建隐形查询地图
        Vue.prototype.$qqmap.queryQQMap = createQueryQQMap();

        // console.log('Vue.prototype.$qqmap',Vue.prototype.$qqmap);

        //解决异步加载问题
        new Vue({
            router,
            store,
            render: h => h(App),

            created(){

                //拦截错误页面
                if($pageError == true)return true;


                //数据初始
                let callback =()=>{

                    /************主题色更改***************/
                    let $themeColor = res.plugInfo.plugInSettings.themeColor;
                    document.body.style.setProperty('--themColor',$themeColor);
                    document.body.style.setProperty('--themActiveColor',hexToRgba($themeColor,.8));
                    document.body.style.setProperty('--themShadow',hexToRgba($themeColor,.8));


                    /***获取poi详情列表***/
                    getPoiDetailDataInfo(res => {

                        // console.log('获取poi详情列表',res);
                        if(res.data.code == 0){
                            let $this =this;

                            res.data.result.filter((item)=>{
                                let $tags = [],
                                    $bussT={week:'',sTime:'',eTime:''},
                                    $bussTStr = '',
                                    $imgURL=[];

                                if(item.tags && JSON.parse(item.tags)){  //标签
                                    JSON.parse(item.tags).map(($item)=>{
                                        $tags.push({name:$item.labelCh})
                                    })
                                }

                                if(item.businessHours && JSON.parse(item.businessHours)){

                                    $bussT = { //营业
                                        week:JSON.parse(item.businessHours)[0].week,
                                        sTime:JSON.parse(item.businessHours)[0].starTime,
                                        eTime:JSON.parse(item.businessHours)[0].endTime
                                    }

                                    //时间拼接
                                    if($bussT.week.length){
                                        $bussTStr += getWeekStr($bussT.week);
                                    }

                                    if($bussT.sTime && $bussT.eTime){
                                        $bussTStr += `  ${$bussT.sTime}~${$bussT.eTime}`
                                    }

                                }

                                if(item.imgUrl && JSON.parse(item.imgUrl).length){
                                    $imgURL = JSON.parse(item.imgUrl);
                                }

                                store.state.POI_DETAIL_DATA.push({
                                    CATEGORY_ID:item.categoryId,
                                    CATEGORY_NAME:item.categoryName,
                                    FLOOR_ID:item.floorId,
                                    FLOOR_NAME:item.floorName,
                                    FLOOR_NUMBER:item.floorNumber,

                                    LABEL_X:'',
                                    LABEL_Y:'',
                                    LAYER: 2,

                                    NAME:item.poiName,
                                    POI_ID:item.poiId,
                                    LOGO:item.logoUrl,

                                    status:item.status,
                                    aptitudeList:item.aptitudeList,
                                    intr:item.intro,
                                    phone:item.phone,
                                    TAGS:$tags,
                                    imgUrl:$imgURL,

                                    bussT:$bussT,
                                    bussTStr:$bussTStr
                                })

                            })

                        }


                        this.$mapEventManger.brandReadyStatus = true;
                        let brandEvents = this.$mapEventManger.brandReadyEvents;

                        if(brandEvents.length){

                            for(let i=0;i<brandEvents.length;i++){
                                brandEvents[i] && brandEvents[i]();
                            }


                            this.$mapEventManger.brandReadyEvents = [];
                        }


                        if(getParam('brand') == 1){
                            router.replace(`/classify?brand=1`)
                        }

                    });

                    /***获取店铺活动列表***/
                    this.bus.$off('getShopActive');
                    this.bus.$on('getShopActive',(option)=>{

                        store.state.ACTIVITY_DATA = [];
                        // option = option || {};
                        // option.callback && option.callback();

                        //店铺活动
                        // getActivityDataInfo(res => {
                        //     // console.log('获取店铺活动列表',res);
                        //
                        //     store.state.ACTIVITY_DATA = [];
                        //
                        //     if(res.data.code==0){
                        //
                        //         res.data.result.map((item)=>{
                        //
                        //             let $status = 0; //正在进行中
                        //
                        //             if(item.status == 1){$status = 2;return false;} //下线
                        //
                        //             else{
                        //
                        //                 if(new Date().getTime() - item.endTime >= 0){   //过期
                        //
                        //                     $status = 2;
                        //                     return false;
                        //
                        //                 }else if(new Date().getTime() - item.startTime < 0){    //即将开始
                        //
                        //                     $status = 1;
                        //                 }
                        //
                        //             }
                        //
                        //             let $count =[]
                        //             if(JSON.parse(item.type)){
                        //                 $count =JSON.parse(item.type);
                        //             }
                        //
                        //             store.state.ACTIVITY_DATA.push({
                        //
                        //                 id:item.id,
                        //
                        //                 CATEGORY_ID:item.categoryId,
                        //                 FLOOR_ID:item.floorId,
                        //                 FLOOR_NAME:item.floorName,
                        //                 FLOOR_NUMBER:item.floorNumber,
                        //                 LABEL_X:'',
                        //                 LABEL_Y:'',
                        //
                        //                 LAYER: 2,
                        //
                        //                 POI_ID:item.poiId,
                        //                 NAME:item.poiName,
                        //
                        //                 //店铺活动
                        //                 topic:item.activityImgUrl,
                        //                 title:item.title,
                        //                 status:$status,
                        //                 count:item.count ? item.count:0,
                        //                 shop:{
                        //                     logo:item.logoUrl,
                        //                     NAME:item.title,
                        //                     floorName:item.floorName
                        //                 },
                        //                 detail:item.contentHtml,
                        //
                        //                 startTime:item.startTime,
                        //                 endTime:item.endTime,
                        //                 sTime:new Date(item.startTime).format('yyyy-MM-dd hh:mm:ss'),
                        //                 eTime:new Date(item.endTime).format('yyyy-MM-dd hh:mm:ss'),
                        //
                        //                 content:item.contentHtml,
                        //
                        //                 imgUrl:item.activityImgUrl,
                        //
                        //                 ACTIVITY_DATA:{
                        //                     title:item.title,
                        //                     count:$count
                        //                 }
                        //             })
                        //
                        //         })
                        //     }
                        //
                        //
                        //     /********改版*******/
                        //     let callback = ()=>{
                        //         _getPoiInfo(this.$brtmap,store.state.ACTIVITY_DATA);
                        //         if(option.callback){option.callback && option.callback()}
                        //     }
                        //
                        //     if(this.$mapEventManger.mapQueryStatus){
                        //         callback && callback();
                        //     }else{
                        //         this.$mapEventManger.mapQueryEvents.push(()=>{
                        //             callback && callback();
                        //         })
                        //     }
                        //
                        //     //获取poi详细信息
                        //     /*
                        //     setTimeout(()=>{
                        //
                        //         _getPoiInfo(this.$brtmap,store.state.ACTIVITY_DATA);
                        //         if(option.callback){option.callback && option.callback()}
                        //
                        //         // console.log('处理的数据ACTIVITY_DATA',store.state.ACTIVITY_DATA);
                        //     },option.time)
                        //     */
                        //
                        // });

                        //广告推送
                        getActivePushInfo(res=>{
                            // console.log('广告推送',res);

                            if(res.data.code==0){
                                res.data.result.map((item)=>{

                                    let $status = 0; //正在进行中

                                    if(!item.adStatus){
                                        $status = 2;
                                        return false;
                                    }

                                    let $count =[]
                                    if(item.type && JSON.parse(item.type)){
                                        $count =JSON.parse(item.type);
                                    }

                                    store.state.ACTIVITY_DATA.push({

                                        id:item.id,

                                        CATEGORY_ID:item.categoryId,
                                        FLOOR_ID:item.floorId,
                                        FLOOR_NAME:item.floorName,
                                        FLOOR_NUMBER:item.floorNumber,
                                        LABEL_X:'',
                                        LABEL_Y:'',

                                        LAYER: 2,

                                        POI_ID:item.poiId,
                                        NAME:item.poiName,

                                        //店铺活动
                                        topic:item.adImgUrl,
                                        title:item.adTitle,
                                        status:$status,
                                        count:item.count ? item.count:0,
                                        shop:{
                                            logo:item.logoUrl,
                                            NAME:item.title,
                                            floorName:item.floorName
                                        },
                                        detail:item.contentHtml,
                                        startTime:item.startTime,
                                        endTime:item.endTime,
                                        sTime:new Date(item.startTime).format('yyyy-MM-dd hh:mm:ss'),
                                        eTime:new Date(item.endTime).format('yyyy-MM-dd hh:mm:ss'),
                                        content:item.contentHtml,
                                        imgUrl:item.adImgUrl,
                                        ACTIVITY_DATA:{
                                            title:item.title,
                                            count:$count
                                        }
                                    });

                                })
                            }


                            /********改版*******/
                            let callback = ()=>{
                                _getPoiInfo(this.$brtmap,store.state.ACTIVITY_DATA);

                                if(option.callback){option.callback && option.callback()}
                            }

                            if(this.$mapEventManger.mapQueryStatus){
                                callback && callback();
                            }

                            else{

                                this.$mapEventManger.mapQueryEvents.push(()=>{
                                    callback && callback();
                                })

                            }

                        })
                    });
                    this.bus.$emit('getShopActive',{})

                    /***获取店铺活动列表***/


                    /***获取主题活动列表***/
                    store.state.THEME_ACTIVITY_DATA_OPEN = false;

                    this.bus.$on('getMainActiveList',(option)=>{
                        getThemeActivity(res=>{

                            // console.log('获取主题活动列表',res);
                            if(res.data.code == 0){

                                store.state.THEME_ACTIVITY_DATA = [[],[]];

                                store.state.THEME_ACTIVITY_DATA_OPEN = res.data.data.open == 0 ? false:true;

                                let $result = JSON.parse(JSON.stringify(res.data.result));

                                $result.map(item=>{

                                    let $store =[];

                                    if(item.joinPoiList.length > 0){

                                        // console.log('item.joinPoiList',item.joinPoiList);

                                        item.joinPoiList.map($item=>{

                                            $store.push({

                                                imgUrl:$item.logoUrl ? $item.logoUrl : '',

                                                poi:{
                                                    POI_ID:$item.poiId ? $item.poiId :'',
                                                    // CATEGORY_ID:$item.CATEGORY_ID ? $item.CATEGORY_ID :'',
                                                    // CATEGORY_NAME:$item.CATEGORY_NAME ? $item.CATEGORY_NAME :'',
                                                    // FLOOR_ID:$item.FLOOR_ID ? $item.FLOOR_ID :'',
                                                    // FLOOR_NAME:$item.floorName ? $item.floorName :'',
                                                    // FLOOR_NUMBER:$item.floorNumber ? $item.floorNumber :'',
                                                    // LABEL_X:$item.LABEL_X ? $item.LABEL_X :'',
                                                    // LABEL_Y:$item.LABEL_Y ? $item.LABEL_Y :'',
                                                    // NAME:$item.poiName ? $item.poiName :'',
                                                }
                                            })

                                        })
                                    }

                                    let $status = 0;

                                    if(item.status == 1){$status = 2;return false;} //下线

                                    else{

                                        $status =0; //正在进行

                                        if(new Date().getTime() - item.endTime >= 0){   //过期

                                            $status = 2;

                                        }else if(new Date().getTime() - item.startTime < 0){   //即将开始
                                            $status = 1;
                                        }

                                    }



                                    let obj = {

                                        id:item.id,
                                        topic:item.imgUrl,
                                        title:item.title,
                                        status:$status,

                                        startTime:item.startTime,
                                        endTime:item.endTime,
                                        sTime:new Date(item.startTime).format('yyyy-MM-dd hh:mm:ss'),
                                        eTime:new Date(item.endTime).format('yyyy-MM-dd hh:mm:ss'),

                                        s_eTime:new Date(item.startTime).format('yyyy.MM.dd') + '-' + new Date(item.endTime).format('yyyy.MM.dd'),
                                        // d_s_eTime: 3天10时 , //距离结束时间
                                        // d_s_sTime:3天10时, //距离开始时间
                                        count:item.count,
                                        area:item.area,
                                        store:$store,
                                        storeLen:item.joinNumber,
                                        detail:item.contentHtml

                                    }

                                    $status > 1 ? store.state.THEME_ACTIVITY_DATA[1].push(obj) : store.state.THEME_ACTIVITY_DATA[0].push(obj)

                                })


                                /****改版*****/
                                let callback = ()=>{

                                    for(let i=0; i<store.state.THEME_ACTIVITY_DATA.length;i++){

                                        let them =store.state.THEME_ACTIVITY_DATA[i];

                                        them.map((item)=>{

                                            if(item.store.length > 0){

                                                item.store.map($store =>{

                                                    if($store.poi){

                                                        if($store.poi.POI_ID){

                                                            $store.poi = _getPoiInfo(this.$brtmap,[$store.poi])[0].poi;

                                                        }

                                                    }

                                                })

                                            }

                                        })

                                    }

                                    if(option.callback){option.callback && option.callback();}

                                    if(getParam('mainActiveID')){ //主题活动详情
                                        router.replace(`/details/2/${getParam('mainActiveID')}?mainActiveID=${getParam('mainActiveID')}`);
                                    }
                                };

                                if(this.$mapEventManger.mapQueryStatus){
                                    callback && callback();
                                }
                                else{
                                    this.$mapEventManger.mapQueryEvents.push(()=>{
                                        callback && callback();
                                    })
                                }

                                //获取poi详细信息
                                /*

                                setTimeout(()=>{

                                    for(let i=0; i<store.state.THEME_ACTIVITY_DATA.length;i++){

                                        let them =store.state.THEME_ACTIVITY_DATA[i];

                                        them.map((item)=>{

                                            if(item.store.length > 0){

                                                item.store.map($store =>{

                                                    if($store.poi){

                                                        if($store.poi.POI_ID){

                                                            $store.poi = _getPoiInfo(this.$brtmap,[$store.poi])[0].poi;

                                                        }

                                                    }

                                                })

                                            }

                                        })

                                    }

                                    if(option.callback){option.callback && option.callback();}

                                    // console.log('处理的数据THEME_ACTIVITY_DATA',store.state.THEME_ACTIVITY_DATA);
                                },option.time)

                                 */
                            }
                        })
                    })

                    this.bus.$emit('getMainActiveList',{})


                    /**************收藏夹、历史足迹初始处理*******************/
                    // store.state.CollectData = [];
                    // store.state.HistoryData = [];

                    if(this.$mapFunManger.collectAndFoots){

                        store.state.CollectData = [];
                        store.state.HistoryData = [];

                        /**********获取收藏夹列表************/
                        getCollectData(this,(res)=>{
                            // console.log('收藏夹',res);
                            store.state.CollectData = res.data.result ? res.data.result:[];
                        });

                        /**********获取历史足迹列表************/
                        getHistoryFootData(this,(res)=>{
                            // console.log('历史足迹',res);
                            store.state.HistoryData = res.data.result ? res.data.result:[];
                        })
                    }

                    /**************推荐信息*******************/
                    getRecommendData(this,(res)=>{

                        // console.log('推荐信息',res);

                        if(res.data.code == 0){

                            store.state.RecommendData =JSON.parse(JSON.stringify(res.data.result));
                            // console.log('res.data.result.business',res.data.result.business,'res.data.result.public',res.data.result.public);

                            //公共设施
                            store.state.RecommendData.publicFormat = res.data.result.public.length ? [] :'';

                            //业态分类
                            store.state.RecommendData.businessFormat = res.data.result.business.length ? [] :'';

                            let $data = [];

                            res.data.result.business.map((item)=>{

                                let icon = item.icon || 'https://files.brtbeacon.net/BRTMap/images/' + item.categoryId + '_normal.png',
                                    searchIcon = item.searchIcon || 'https://files.brtbeacon.net/BRTMap/images/' + item.categoryId + '_normal.png';


                                //切换导致有时数据为空
                                $data.push({
                                    CATEGORY_ID:item.categoryId,
                                    icon:icon,
                                    searchIcon:searchIcon,
                                    name:item.title,
                                    level:item.level,
                                    priority:item.priority
                                })

                            })

                            //排序
                            $data.sort((v1,v2)=>{return v1.priority - v2.priority});

                            //业态分类分屏(提前分好数据)
                            while ($data.length){
                                store.state.RecommendData.businessFormat.push($data.splice(0, 8));
                            }

                            res.data.result.public.map((item)=>{

                                let icon = item.icon || 'https://files.brtbeacon.net/BRTMap/images/' + item.categoryId + '_normal.png',
                                    searchIcon = item.searchIcon || 'https://files.brtbeacon.net/BRTMap/images/' + item.categoryId + '_normal.png';

                                store.state.RecommendData.publicFormat.push({
                                    CATEGORY_ID:item.categoryId,
                                    name:item.title,
                                    level:item.level,
                                    imgUrl:icon,
                                    icon:icon,
                                    searchIcon:searchIcon,
                                    priority:item.priority
                                })

                            })

                            //排序
                            if(store.state.RecommendData.publicFormat.length > 1){
                                store.state.RecommendData.publicFormat.sort((v1,v2)=>{ return v1.priority - v2.priority})
                            }

                        }

                    })

                    /***************获取热词**************/
                    getHotWords(this,(res)=>{
                        if(res.data.code == 0){

                            //设置热词
                            let $setHOT = res.data.result.filter(item=>{
                                    return item.type == 0
                                }),

                                $hotData = [];

                            if($setHOT.length){

                                if($setHOT.length>1){

                                    $setHOT = $setHOT.sort((v1,v2)=>{
                                        return v1.priority - v2.priority
                                    })
                                }

                                $hotData = $setHOT;
                            }

                            if(!$hotData.length){
                                $hotData = res.data.result;
                                //升序
                                $hotData = $hotData.sort((v1,v2)=>{
                                    return v2.totalClick - v1.totalClick;
                                })
                            }

                            //截取前面20个
                            store.state.hot_Word = $hotData.length > 20 ? $hotData.splice(0,20) : $hotData;

                        }
                    })

                    /***********获取区域触发列表****************/
                    getNavAreaPoint(this,(res)=>{

                        // store.state.NAVAREAPOINT_DATA
                        // console.log('区域触发点位列表',res);

                        if(res.data.code == 0){

                            res.data.result.map((item)=>{

                                store.state.NAVAREAPOINT_DATA.push({
                                    title:item.title,
                                    icon:item.imgUrl.replace(/\"/g,''),
                                    text:item.details,

                                    point:{
                                        CATEGORY_ID:"",
                                        CATEGORY_NAME:"",
                                        FLOOR_ID:item.floorId,
                                        FLOOR_NAME:"",
                                        FLOOR_NUMBER:"",
                                        LABEL_X:item.labelX,
                                        LABEL_Y:item.labelY,
                                        NAME:"",
                                        POI_ID:"",
                                    },
                                    status:item.status,
                                    distant:item.radius,
                                })

                            })

                        }

                        // console.log('store.state.NAVAREAPOINT_DATA',store.state.NAVAREAPOINT_DATA);
                    })


                    /***********申明获取定位点与其点位的距离**************/
                    this.bus.$off('getDistant')
                    this.bus.$on('getDistant',(data)=>{

                        let $this =this,
                            $brtmap = $this.$store.state.mapStore.brtmap,
                            locationPoint = JSON.parse(JSON.stringify($brtmap.$locate.point)),
                            point = data.point,
                            callback = data.callback,

                            $data = {};


                        // console.log('获取距离次数是否正确');

                        if(locationPoint){

                            if(!(locationPoint.LABEL_X && locationPoint.LABEL_Y)){
                                locationPoint = {
                                    LABEL_X:locationPoint.x,
                                    LABEL_Y:locationPoint.y,
                                    FLOOR_NUMBER:locationPoint.floor
                                }
                            }

                            // 是否跨层
                            if(locationPoint.FLOOR_NUMBER != point.FLOOR_NUMBER){
                                $data.cross = true
                            }else{
                                $data.cross =false
                            }


                            if(data.type && data.type == 1){   //直线距离

                                let d =  Math.sqrt((locationPoint.LABEL_X - point.LABEL_X) * (locationPoint.LABEL_X - point.LABEL_X) + (locationPoint.LABEL_Y - point.LABEL_Y) * (locationPoint.LABEL_Y - point.LABEL_Y));
                                $data.distance = Math.ceil(d);
                                callback && callback($data);
                                return d
                            }

                            //夸楼层
                            if(locationPoint.FLOOR_NUMBER != point.FLOOR_NUMBER){

                                var features = $VAR.map.querySourceFeatures("brtbeaconSource", {sourceLayer:'fill', filter:["==",'floor', point.FLOOR_NUMBER]}),

                                    minDistance = 1000000,

                                    minDistPOI = null;

                                for(var i = 0; i < features.length; i++){

                                    //楼梯、扶梯、电梯
                                    if(['150014','150013','150012'].indexOf(features[i].properties.CATEGORY_ID) > -1){

                                        var poi = features[i].properties;

                                        var d = Math.sqrt((locationPoint.LABEL_X - poi.LABEL_X) * (locationPoint.LABEL_X - poi.LABEL_X) + (locationPoint.LABEL_Y - poi.LABEL_Y) * (locationPoint.LABEL_Y - poi.LABEL_Y));
                                        if(d < minDistance){
                                            minDistance = d;
                                            minDistPOI = poi;
                                        }

                                    }

                                }

                                if(minDistPOI){

                                    var d = Math.sqrt((minDistPOI.LABEL_X - point.LABEL_X) * (minDistPOI.LABEL_X - point.LABEL_X) + (minDistPOI.LABEL_Y - point.LABEL_Y) * (minDistPOI.LABEL_Y - point.LABEL_Y));

                                    $data.distance = Math.ceil(minDistance + d);

                                    callback && callback($data);

                                    return minDistance + d;

                                }

                                callback && callback();
                                return null;

                            }
                            else{

                                let d =  Math.sqrt((locationPoint.LABEL_X - point.LABEL_X) * (locationPoint.LABEL_X - point.LABEL_X) + (locationPoint.LABEL_Y - point.LABEL_Y) * (locationPoint.LABEL_Y - point.LABEL_Y));
                                $data.distance = Math.ceil(d);
                                callback && callback($data);
                                return d
                            }

                        }

                        callback && callback();
                        return null;

                    })


                    /***********判断类型图标不存在处理**************/
                    // this.bus.$off('CATEGORYID_ICON_TRUE')

                    this.bus.$on('CATEGORYID_ICON_TRUE',(data)=>{

                        let $type = data.type,
                            $ICON_URL = data.ICON,
                            $callback = data.callback;

                        request.get($ICON_URL).then(($data)=>{

                            $callback && $callback(false)   //不处理

                        }).catch((err)=>{

                            if(err.message.match('404')){   //图片不存在

                                if($type == 1){//筛选图标
                                    $ICON_URL = './images/filter_null.png';
                                    $callback && $callback($ICON_URL);
                                    return;
                                }

                                //插标处理
                                $ICON_URL = './images/selecte_null.png';
                                $callback && $callback($ICON_URL);
                            }

                        })

                    })


                    /********初始接入页面控制********/
                        // console.log('JSON.stringify(res.plugInfo.plugInSettings.apply).searchBefore',JSON.parse(res.plugInfo.plugInSettings.apply).searchBefore);
                    let $URLCALLBACK = ()=>{

                        // if(['QQMap','QQSearch','QQRoute'].indexOf(this.$route.name) > -1){
                        //
                        // }else

                            if(getParam('parking')==1){
                                router.replace('/parking?parking=1');
                            }

                            else if(getParam('findCar') == 1){   //寻车

                                if(this.$mapStore.plugInfo.plugInfo.plugInSettings.queryCarServiceOpen !=1){ //拦截服务

                                    this.$message.info('暂未开通寻车服务');

                                    router.replace(`/map`);

                                }else{

                                    this.$router.replace('/findCar?findCar=1');

                                    /*
                                    let $url = `/findCar?findCar=1`;
                                    //其他操作参数截取
                                    this.$BRT.$urlParam.findCar.status = true;

                                    if(getParam('enterType')){
                                        this.$BRT.$urlParam.findCar.enterType = getParam('enterType');
                                        $url +=`&enterType=${getParam('enterType')}`
                                    }

                                    if(getParam('carNo')){
                                        this.$BRT.$urlParam.findCar.carNo = decodeURI(escape(getParam('carNo')));
                                        $url +=`&carNo=${decodeURI(escape(getParam('carNo')))}`
                                    }

                                    if(getParam('buildingId')){
                                        this.$BRT.$urlParam.findCar.buildingId = getParam('buildingId');
                                        $url +=`&buildingId=${getParam('buildingId')}`
                                    }

                                    if(getParam('userId')){
                                        this.$BRT.$urlParam.findCar.userId = getParam('userId');
                                        $url +=`&userId=${getParam('userId')}`
                                    }

                                    if(getParam('applyId')){
                                        this.$BRT.$urlParam.findCar.applyId = getParam('applyId');
                                        $url +=`&applyId=${getParam('applyId')}`
                                    }
                                    router.replace($url);
                                }
                                */
                                }

                            }

                            else if(getParam('brand') == 1){   //品牌列表

                                // router.replace(`/classify?brand=1`)

                            }

                            else if(getParam('mainActive')== 1){  //主题活动

                                router.replace(`/activity?mainActive=1`)

                            }

                            else if(getParam('mainActiveID')){ //主题活动详情
                                // router.replace(`/details/2/${getParam('mainActiveID')}?mainActiveID=${getParam('mainActiveID')}`);
                            }

                            // else  if(getParam('shopActiveID')){//单店活动详情（选中）
                            //
                            //     // router.replace('/details/1/'+getParam('shopActiveID'));
                            //     // this.$message.load(true);
                            //     this.$BRT.$urlParam.shopActive.status = true;//先进入单店版块
                            //
                            //     this.$BRT.$urlParam.shopActive.selete = getParam('shopActiveID');   //选中ID
                            //
                            // }

                            else if(
                                getParam('poiId') ||
                                getParam('map') == 1 ||
                                getParam('shopActive') == 1 ||
                                getParam('shopActiveID') ||
                                getParam('filterNAME')||
                                getParam('planRoute') ||
                                getParam('nearLift') ||
                                getParam('findNullPark') ||
                                (JSON.parse(res.plugInfo.plugInSettings.apply).searchBefore != 'before' && !getParam('search'))
                            ){

                                if(getParam('poiId')){  //poi点位分享

                                    this.$message.load(true);

                                    let $poiId = getParam('poiId');

                                    // console.log('$poiId',$poiId,'url',window.location.href);
                                    if($poiId){

                                        if($poiId == 'location'){   //当前定位点

                                            this.$BRT.$urlParam.share={
                                                NAME:'无名地址',
                                                LABEL_X:getParam('LABEL_X'),
                                                LABEL_Y:getParam('LABEL_Y'),
                                                FLOOR_NUMBER:getParam('FLOOR_NUMBER')
                                            };

                                        }

                                        this.$BRT.$urlParam.share.poiId = $poiId;
                                    }

                                }
                                else if(getParam('shopActive') == 1 || getParam('shopActiveID')){  //店铺活动

                                    this.$message.load(true);
                                    this.$BRT.$urlParam.shopActive.status = true;

                                    if(getParam('shopActiveID')){

                                        this.$BRT.$urlParam.shopActive.selete = getParam('shopActiveID');   //选中ID

                                    }

                                }else if(getParam('filterNAME')){   //根据name查数据

                                    this.$message.load(true);
                                    this.$BRT.$urlParam.filter.status = true;
                                    this.$BRT.$urlParam.filter.name= decodeURI(escape(getParam('filterNAME')));

                                }else if(getParam('findNullPark')){ //寻找空车位（空车位地图）

                                    this.$message.load(true);
                                    this.$BRT.$urlParam.findNullPark.status = true;

                                }

                                else if(getParam('nearLift')){ //周边电梯

                                    this.$message.load(true);
                                    this.$BRT.$urlParam.nearLift.status = true;
                                    this.$BRT.$urlParam.nearLift.type = getParam('nearLift') - 0;

                                }

                                else if(getParam('planRoute')){ //规划路径

                                    this.$message.load(true);
                                    this.$BRT.$urlParam.planRoute.status = true;

                                    if(getParam('startPoi')){
                                        this.$BRT.$urlParam.planRoute.startPoi = getParam('startPoi');
                                    }

                                    if(getParam('endPoi')){
                                        this.$BRT.$urlParam.planRoute.endPoi = getParam('endPoi');
                                    }

                                    if([getParam('startPoi'),getParam('endPoi')].indexOf('locate') > -1){
                                        this.$BRT.$urlParam.planRoute.x = getParam('x');
                                        this.$BRT.$urlParam.planRoute.y = getParam('y');
                                        this.$BRT.$urlParam.planRoute.floor  = getParam('floor');
                                        this.$BRT.$urlParam.planRoute.name = '无名地址';
                                    }

                                }


                                //无操作刷新保存原状
                                let urlstr = '',urlval='';

                                if(getParam('poiId')){

                                    urlstr = 'poiId';
                                    urlval = getParam('poiId');

                                    if(getParam('poiId') == 'location'){
                                        urlval = `${getParam('poiId')}&LABEL_X=${getParam('LABEL_X')}&LABEL_Y=${getParam('LABEL_Y')}&FLOOR_NUMBER=${getParam('FLOOR_NUMBER')}`
                                    }

                                }else if(getParam('shopActive')){
                                    urlstr = 'shopActive';
                                    urlval = getParam('shopActive');
                                }else if(getParam('shopActiveID')){

                                    urlstr = 'shopActiveID';
                                    urlval = getParam('shopActiveID');

                                }else if(getParam('filterNAME')){

                                    urlstr = 'filterNAME';
                                    urlval = this.$BRT.$urlParam.filter.name;

                                }else if(getParam('findNullPark')){

                                    urlstr = 'findNullPark';
                                    urlval = getParam('findNullPark');

                                }else if(getParam('nearLift')){

                                    urlstr = 'nearLift';
                                    urlval = getParam('nearLift');

                                }else if(getParam('planRoute')){

                                    urlstr = 'planRoute';
                                    urlval = getParam('planRoute');

                                    if(getParam('startPoi')){

                                        urlval += `&startPoi=${getParam('startPoi')}`;
                                    }

                                    if(getParam('endPoi')){
                                        urlval += `&endPoi=${getParam('endPoi')}`
                                    }

                                    if([getParam('startPoi'),getParam('endPoi')].indexOf('locate') > -1){
                                        urlval +=`&x=${getParam('x')}&y=${getParam('y')}&floor=${getParam('floor')}`
                                    }

                                }


                                let $url='/map'

                                if(urlstr){

                                    //带上sign
                                    // urlval +=`&sign=${res.sign}`;

                                    let $param = `${urlstr ? '?'+urlstr+'=' : ''}${urlval}`;
                                    $url+=$param;

                                }else{
                                    // $url +=`?sign=${res.sign}`
                                }

                                router.replace($url);

                            }

                            else{

                                if(getParam('search')){

                                    router.replace(`/search?search=1`)

                                }else{
                                    router.replace(`/search`)
                                }

                            }
                        }
                    $URLCALLBACK();

                    // this.bus.$emit('CATEGORYID_ICON_TRUE',{
                    //     ICON:'https://files.brtbeacon.net/BRTMap/images/001300_normal.png'
                    // })

                }

                //挂载地图到brtmapDOM
                document.getElementById('brtmapDOM').appendChild($VAR.container);
                //地图初始相关准备
                let $this = this,
                    $plugInfo = $this.$store.state.mapStore.plugInfo.plugInfo,
                    $brtmap = $this.$store.state.mapStore.brtmap;

                $brtmap.map = {};

                let $callback = ()=>{

                    //实例化所需图标
                    _init_makers($brtmap);

                    //定位实例
                    _init_locate($brtmap, $plugInfo);

                    //搜索
                    // $VAR.brtmapSearch = $VAR.brtmapSearch;

                    //地图文字基础设置
                    let $mapBaseSetting = JSON.parse($plugInfo.plugInSettings.map);

                    $this.$nextTick(()=>{
                        $VAR.map.setFont({

                            'color':$mapBaseSetting.fontColor ? $mapBaseSetting.fontColor:"#666666",
                            'size':10,
                            'haloColor':$mapBaseSetting.fontBorder? $mapBaseSetting.fontBorder : "#ffffff",
                            'haloWidth':1,

                        });
                    })

                    //监听地图指针
                    //地图/指针夹角(解决实际场景定位指针与指北问题)
                    let pointerAngle = $mapBaseSetting.pointerAngle || 0;

                    let buildingInitAngle = $VAR.map.building.initAngle || 0;

                    let initAngle = Math.floor(pointerAngle) + Math.floor(buildingInitAngle);

                    $brtmap.$NAVTO.initAngle = initAngle;   //添加初始值

                    //定位指针初始指向
                    $brtmap.$NAVTO.angle = 360 - $mapBaseSetting.rotateAngle - initAngle;

                    //定位指针随地图转动
                    $VAR.map.on('rotate', (e) => {

                        $brtmap.$NAVTO.angle = -e.target.getBearing() - e.target.building.initAngle;

                    })

                    //地图大小，旋转度，倾斜度初始设置
                    $this.$nextTick(()=>{
                        $VAR.map.easeTo({
                            pitch:$mapBaseSetting.inclineAngle >=0 ? $mapBaseSetting.inclineAngle : 30,
                            bearing:$mapBaseSetting.rotateAngle >=0 ? $mapBaseSetting.rotateAngle : 0,
                            zoom:$mapBaseSetting.zoom >=0 ? $mapBaseSetting.zoom : 18   //$VAR.map.getBaseZoom()
                        })
                    })

                    //监听楼层切换完成后
                    $brtmap.$marker.navLocation.setCommpassAngle($brtmap.$NAVTO.initAngle);

                    let $setinitAngle = false;

                    $VAR.map.on('floorend',(e) =>{

                        //设置正北偏移角度(惯性导航需求)
                        if(!$setinitAngle){
                            $setinitAngle = true;
                            $brtmapLocate.initAngle = $brtmap.$NAVTO.initAngle;
                        }

                        //插标实景
                        $this.bus.$emit('Map.photosphere',1)
                        //console.log('变量$VAR',$VAR);

                        //切换楼层监听
                        let floor = $VAR.map.currentMapInfo;

                        $this.bus.$emit('FloorModuleListenFLoor',floor);

                        $this.bus.$emit('MapFloorListen',floor);

                        $this.bus.$emit('poiInfoFloorListen',floor);

                        $this.bus.$emit('PoiListDrawerFloorListen',floor);

                        // if(!!$brtmapLocate){
                        //
                        //     $brtmapLocate.initAngle = $brtmap.$NAVTO.initAngle;
                        //
                        //     /***版本升级弃用***/
                        //     // $brtmapLocate.setInertiaConfig({
                        //     //     initAngle: $brtmap.$NAVTO.initAngle,
                        //     //     accuracy:0.1
                        //     // });
                        // }
                    });

                    //监听倾斜度变化 2,3d切换
                    $VAR.map.on('pitchend',(e)=>{
                        // console.log('$pitch',$pitch);
                        let $pitch = Math.round($VAR.map.getPitch())
                        $brtmap.$options.use3D = $pitch> 30 ? true : false
                    })

                    //监听地图层级
                    // $VAR.map.on('zoomend',(e)=>{
                    //
                    //    let $zoom = $VAR.map.getZoom(),
                    //        $maxZoom = $VAR.map.getMaxZoom() > 22 ? 22 : $VAR.map.getMaxZoom(),
                    //
                    //        $minZoom =$VAR.map.getMinZoom() > 0 ? ($VAR.map.getMinZoom() < $mapBaseSetting.zoom ? $mapBaseSetting.zoom : $VAR.map.getMinZoom()):
                    //                ($VAR.map.getBaseZoom() < $mapBaseSetting.zoom ? $mapBaseSetting.zoom :$VAR.map.getBaseZoom());
                    //
                    //        $minZoom = $minZoom < 15 ? 15 : $minZoom;
                    //
                    //    // console.log('$maxZoom',$maxZoom,'$minZoom',$minZoom,'$VAR.map.getMinZoom()',$VAR.map.getMinZoom());
                    //    // console.log('$zoom',$zoom,'$mapBaseSetting.zoom',$mapBaseSetting.zoom);
                    //
                    //    if($zoom <= $minZoom){
                    //        $this.$message.info('已缩小到最小级别');
                    //        $VAR.map.setMinZoom($minZoom);
                    //    }else if($zoom >= $maxZoom){
                    //        $this.$message.info('已放大到最大级别');
                    //        $VAR.map.setMaxZoom($maxZoom);
                    //    }
                    //
                    // })
                }

                $VAR.map.on('mapready',()=>{

                    //初始及相关监听
                    $callback && $callback();

                    callback();

                })

                $VAR.map.on('click', (res) => {

                    // console.log('res',res);

                    /*****************定位点测试*********************/
                    // if(!$brtmap.$locate.point || (this.$mapStep.type == 'toNAVING' && this.$BRT.$NAVTO.NAVType == 'NAVINDICATE')){
                    //
                    //     //信号值变化
                    //     let $rssi = this.$BRT.$NAVTO.testPoint ? ( this.$BRT.$NAVTO.testPoint.rssi >= 4 ? 0 : this.$BRT.$NAVTO.testPoint.rssi + 1)  : 0
                    //
                    //     // console.log('$rssi',$rssi);
                    //     let point ={
                    //         x:$VAR.map.lnglatToCoords(res.lngLat).x,
                    //         y:$VAR.map.lnglatToCoords(res.lngLat).y,
                    //         floor:$VAR.map.currentMapInfo.floorNumber,
                    //         lng:res.lngLat.lng,
                    //         lat:res.lngLat.lat,
                    //         angle:0,
                    //         rssi:0
                    //     }
                    //
                    //     this.$BRT.$NAVTO.testPoint = point;
                    //     $brtmap.$locate.point = point;
                    //
                    //     this.bus.$emit('naving',point); //导航测试
                    //
                    //     // this.bus.$emit('getNearLift',point);    //附近电梯设置
                    //
                    //     // this.bus.$emit('getPlanRoute_start',point);//规划路径获取起点
                    //
                    // }

                    //缩小筛选
                    if($this.$mapStep.type =='toFilter'){this.$BRT.$options.PoiListDrawer = 1;}

                    /*******选点 避免查不到数据干扰***********/
                    if($this.getPoiInfo(res.point)){

                        if($brtmap.$urlParam.share.status)return;   //分享屏蔽选点

                        let poiInfo;

                        $VAR.brtmapSearch.query({
                            type:'poiid',
                            value:$this.getPoiInfo(res.point).POI_ID
                        }, function (result) {

                            poiInfo = result.filter((item,index,self)=>{
                                return item.POI_ID == $this.getPoiInfo(res.point).POI_ID
                            })[0];

                        });

                        if(poiInfo){

                            // console.log('poiInfo',poiInfo);

                            if( this.$mapStep.type == 'planRoute' || this.$mapStep.type == 'toNAVING' || this.$mapStep.type == 'shopActive'){

                                //地图选点
                                this.$BRT.$route.selectType.type == 'map' ? this.$set(this.$BRT.$route.selectType,'point',$this.getPoiInfo(res.point).POI_ID):''

                            }else{


                                //筛选选点返回限制
                                if(this.$mapStep.type == 'toFilter'){this.$BRT.$filter.enter = 'Filter'}

                                //poi显示
                                this.$mapStep.type == 'selectePOI' ? '': this.$mapStep.type = 'selectePOI';
                                this.$BRT.$options.PoiListDrawer = 0;
                                this.$mapStep.poiID=$this.getPoiInfo(res.point).POI_ID;
                                this.bus.$emit('selectedPoint',this.$mapStep.poiID);
                            }

                        }
                    }

                    // 图标点测试
                    // $brtmap.$marker.virtualLocation.setLnglat(res.lngLat,$VAR.map.currentMapInfo.floorNumber);
                    // $brtmap.$marker.location.setLnglat(res.lngLat,$VAR.map.currentMapInfo.floorNumber);
                    // $brtmap.$marker.navLocation.setLnglat(res.lngLat,$VAR.map.currentMapInfo.floorNumber);
                    // $brtmap.$marker.selected.setLnglat(res.lngLat);
                    // $brtmap.$marker.start.setLnglat(res.lngLat);
                    // $brtmap.$marker.end.setLnglat(res.lngLat);
                    // $brtmap.$marker.filter.setLnglat(res.lngLat);
                    // $brtmap.$marker.tipPopup.setLnglat(res.lngLat);
                    // $brtmap.$marker.shopActive.setLnglat(res.lngLat)
                })

                /********定位资源前置******/
                get_wx_sign(this.$store.state.mapStore,this.wx,()=>{

                    let $wxstatus = this.$mapEventManger.mapWxReadyStatus,
                        $wxlist = this.$mapEventManger.mapWxReadyEvents;

                    this.$mapEventManger.mapWxReadyStatus = true;

                    if($wxlist.length){

                        for(let i=0;i<$wxlist.length;i++){
                            $wxlist[i] && $wxlist[i]();
                        }

                        this.$mapEventManger.mapWxReadyEvents = [];
                    }


                    let $this = this,
                        $plug = $this.$mapStore.plugInfo.plugInfo,
                        $sign = sessionStorage.getItem('sign'),
                        $link = $sign? window.location.href.split('?')[0] + '?sign='+$sign : window.location.href.split('?')[0],
                        $share = {
                            title:$plug.name,
                            desc:'好友分享了此场景室内地图应用，一键导航、寻店、寻人等，点击查看',
                            imgUrl:$plug.plugInSettings.shareIcon,
                            link:$link,
                            init:true
                        },

                        shareCallback = (res)=>{

                            //设置分享信息 （分享标识[可不传，但是必须要接收并且分享时，需要将这个ID写入链接中；用户点击进来的时候，再来源那里设置该ID和类型]，分享业务类型[1：主题活动；2：店铺活动；3：其他页面；4：POI；5：其他], 分享业务ID[主题活动页面ID/店铺活动页面ID/其他页面ID/POIID]）
                            if(res.poiId){
                                //分享
                                $this.$userUpdata.setShare('',4,res.poiId);
                            }

                            else if(!res.init){
                                //其他
                                $this.$userUpdata.setShare('',5,'');
                            }

                            if($systemEnviron() == 2 && !res.init){

                                let message = {...res};
                                //?{0} &{1} ={2} #{3}
                                message.link = message.link.replace(/\?/g,'{0}').replace(/&/g,'{1}').replace(/=/g,'{2}').replace(/#/g,'{3}');
                                // console.log('小程序分享',message);

                                // let link = message.link.replace(/\{0\}/g,'?').replace(/\{1\}/g,'&').replace(/\{2\}/g,'=').replace(/\{3\}/g,'#')
                                // console.log('还原',link);

                                //中文
                                message.language = 'ch';

                                //小程序
                                $this.wx.miniProgram.navigateTo({
                                    url:`/pages/h5Share/h5Share?shareMessage=${JSON.stringify(message)}`
                                })

                            }

                            else{

                                // 分享到朋友圈
                                $this.wx.onMenuShareTimeline({
                                    title:res.title, // 分享标题
                                    link: res.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                                    imgUrl: res.imgUrl, // 分享图标
                                    success: function () {
                                        // 用户确认分享后执行的回调函数
                                    },
                                    cancel: function () {
                                        // 用户取消分享后执行的回调函数
                                    }
                                });

                                // 分享给朋友
                                $this.wx.onMenuShareAppMessage({
                                    title: res.title, // 分享标题
                                    desc: res.desc, // 分享描述
                                    link: res.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                                    imgUrl: res.imgUrl, // 分享图标
                                    success: function () {
                                    },
                                    cancel: function () {
                                        // 用户取消分享后执行的回调函数
                                    }
                                });

                            }
                        };

                    shareCallback && shareCallback($share);

                    //分享设置
                    $this.bus.$off('share_config');
                    $this.bus.$on('share_config',(res)=>{
                        shareCallback && shareCallback(res);
                    })

                })
            },

            methods:{

                getPoiInfo(point,cidNumber){
                    let $this =this,$brtmap = $this.$store.state.mapStore.brtmap,

                        poiInfo=getPoiInfo($brtmap,point,cidNumber);

                    return poiInfo;
                }

            },

        }).$mount('#app');

    });
}
